import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from 'react-router-dom';
import MainContainer from '../../components/MainContainer/MainContainer';

import styles from './PainelBeneficios.module.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { obterFamilia, selectExtratoConsignado, selectFamilia } from './BeneficiosSlice';
import auth from '../../auth/Auth';
import { currencyFormat } from '../../common/formatadores';
import moment from 'moment';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import Accordion, { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';
import { Card, Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import Skeleton from 'react-loading-skeleton';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const ExtratoConsignadoAuxilioBrasil: React.FC = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [informacaoSituacao, setInformacaoSituacao] = useState(false);
  const [explicacaoSituacao, setExplicacaoSituacao] = useState(false);

  const [informacaoValorLiberado, setInformacaoValorLiberado] = useState(false);

  const extratosConsignado = useAppSelector(selectExtratoConsignado);

  const familia = useAppSelector(selectFamilia);
  const perfil = useAppSelector(selectPerfilCompleto);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  useEffect(() => {
    if (!familia) {
      dispatch(obterFamilia(auth.getUser()));
    }

    if (!extratosConsignado) {
      history.push("/home");
    }
  }, [dispatch, familia, perfil]);

  const voltarParaPainel = () => {
    history.goBack();
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const formatarCompetencia = (competencia: string) => {
    const anoCompetencia = competencia.toString().substring(0,4);
    const mesCompetencia = competencia.toString().substring(4,6);

   return mesCompetencia + "/" + anoCompetencia;
  };


  const obterExplicacaoSituacao = (codigo) => {
    const situacoes = [
      {codigo:0, descricao: "ATIVO - Contrato vigente (ocupando a margem consignável), com parcelas sendo descontadas da família e repassadas à instituição financeira."},
      {codigo:2, descricao: "EXCLUÍDO - Contrato excluído pela instituição financeira, sem descontos e sem ocupação da margem consignável da família."},
      {codigo:3, descricao: "ENCERRADO - Contrato com vigência expirada, sem descontos e sem ocupação da margem consignável da família."},
      {codigo:7, descricao: "SUSPENSO - Contrato sem descontos, mas ocupando a margem consignável da família."},
    ]

    let situacao:any = situacoes.find(s => s.codigo === codigo)

    return situacao.descricao;
  };

  const handleExplicacaoSituacao = (codigo) => {
    setInformacaoSituacao(!informacaoSituacao);
    setExplicacaoSituacao(obterExplicacaoSituacao(codigo));
  };



  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={"Empréstimos consignados"}
      barraAuxiliar={true}
      navFixed
      stoppedTitle={true}
      navSeparator={false}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={logout}
      navGoBack={voltarParaPainel}>
        <div className={styles.container} id="topo">
          {!extratosConsignado &&
            <Card className={styles.card}>
              <Skeleton count={15}/>
            </Card>
          }

          {extratosConsignado?.map((consignado, index) => {
            return  (
              <Accordion
                id={`consignado-${index}`}
                title={`${consignado.descricaoSituacao}`}
                subtitle={`Data de realização do contrato: ${consignado.dataRealizacaoContrato ? moment(consignado.dataRealizacaoContrato).format('DD/MM/YYYY') : '-'} `}
                secondSubtitle={`Valor liberado: ${consignado.valorLiberado ? currencyFormat(consignado.valorLiberado) : '-'} `}
                key={index}
                scroll
                className={""}
                scrollOffset={SCROLL_OFFSET_NAV_FIXED}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Dialog
                      open={informacaoSituacao}
                      onClose={() => setInformacaoSituacao(false)}
                    >
                        <DialogContent >
                          <DialogContentText>
                            <div className={styles.textoDialogo}>
                              {explicacaoSituacao}
                            </div>
                          </DialogContentText>
                        </DialogContent>
                    </Dialog>

                    <FieldGroup
                      label={<>
                        <div>Situação
                          <i
                            className={`fas fa-question-circle ${styles.helpIcon}`}
                            onClick={() => handleExplicacaoSituacao(consignado.codigoSituacao)}
                          />
                        </div>
                      </>}
                      value={consignado.descricaoSituacao}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FieldGroup
                      label="Data de realização do contrato"
                      value={consignado.dataRealizacaoContrato ? moment(consignado.dataRealizacaoContrato).format('DD/MM/YYYY') : '-'}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FieldGroup
                      label="Número do contrato"
                      value={consignado.numeroContrato}
                      size="sm"
                    />
                  </Grid>

                  {consignado.codigoSituacao === 2 &&
                    <Grid item xs={12}>
                      <FieldGroup
                        label="Motivo exclusão"
                        value={consignado.motivoSuspensao}
                        size="sm"
                        />
                    </Grid>
                  }

                  <Grid item xs={6}>
                    <FieldGroup
                      label="Início desconto"
                      value={formatarCompetencia(consignado.inicioDesconto)}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldGroup
                      label="Fim desconto"
                      value={formatarCompetencia(consignado.fimDesconto)}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FieldGroup
                      label="Quantidade de parcelas"
                      value={consignado.totalParcelas}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldGroup
                      label="Valor emprestado"
                      value={consignado.valorEmprestimo ? currencyFormat(consignado.valorEmprestimo) : '-'}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldGroup
                      label="Valor da parcela"
                      value={consignado.valorParcela ? currencyFormat(consignado.valorParcela) : '-'}
                      size="sm"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Dialog
                      open={informacaoValorLiberado}
                      onClose={() => setInformacaoValorLiberado(false)}
                    >
                      <DialogContent>
                        <DialogContentText>
                          <div className={styles.textoDialogo}>
                          Valor depositado em conta corrente.
                          </div>
                        </DialogContentText>
                      </DialogContent>
                    </Dialog>

                    <FieldGroup
                      label={<>
                        <div>Valor liberado
                          <i
                            className={`fas fa-question-circle ${styles.helpIcon}`}
                            onClick={() => setInformacaoValorLiberado(true)}
                          />
                        </div>
                      </>}
                      value={consignado.valorLiberado ? currencyFormat(consignado.valorLiberado) : '-'}
                    />
                  </Grid>
                </Grid>
              </Accordion>
            )
          })}
        </div>
    </MainContainer>
  )
}

export default ExtratoConsignadoAuxilioBrasil;
